module.exports = __webpack_public_path__ + "assets/word_cost_control_default.001c50e6.svg";